<template>
    <div class="contact">
        <div class="contactBox">
            <div v-if="isSdkReady" @click="onlineKF">
                <!-- <img class="icon" src="@/assets/KF.png" alt="">
                <div class="slide-title">在线客服</div> -->
                <img class="iconText" src="@/assets/onlineicon.png" alt="">
            </div>
            <!-- <span class="line" v-if="isSdkReady"></span> -->
            <div>
                <el-popover
                    placement="left"
                    trigger="hover">
                    <div class="content"><img class="wecomCode" src="@/assets/wecomCode.jpg" alt=""></div>
                    <div slot="reference">
                        <!-- <img class="icon" src="@/assets/weixinicon.png" alt="">
                        <div class="slide-title">微信咨询</div>                         -->
                        <img class="iconText" src="@/assets/wechaticon.png" alt="">
                    </div>
                </el-popover>
            </div>
            <!-- <span class="line"></span> -->
            <div>
                <el-popover
                    placement="left"
                    trigger="hover">
                    <div class="content">
                        <a href="tel:4000017748">联系电话：400-001-7748</a>
                    </div>
                    <div slot="reference">
                        <!-- <img class="icon" src="@/assets/callme.png" alt="">
                        <div class="slide-title">电话咨询</div>                         -->
                        <img class="iconText" src="@/assets/callmeicon.png" alt="" style="margin-bottom: 0;">
                    </div>
                </el-popover>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "contact",
  data(){
    return{
        isSdkReady:false,
    }
  },
  mounted(){
    ysf('onready', ()=> {
        // this.isSdkReady = true;
    })
  },
  methods:{
    onlineKF(){
        if(this.isSdkReady) {
            ysf('config', {
                title:'刘燕酿制官网',
                referrer:location.href,
                success: function(){     // 成功回调
                    ysf('open',{'templateId':6674864});
                },
                error: function(){       // 错误回调
                    // handle error
                }
            })
            

            // location.href = ysf('url');

            // var left = (screen.width / 2) - (842 / 2);
            // var top = (screen.height / 2) - (632 / 2);
            // if(screen.width>=1200){
            //     window.open(ysf('url',{
            //         'templateId':6674864
            //     }), '_blank', `width=842,height=632,top=${top},left=${left},resizable=yes`);
            // }else{
            //     ysf('open',{
            //         'templateId':6674864
            //     });
            // }
        }
    }
  }
}
</script>
<style scoped lang="less">
.wecomCode{
    width: 2rem;
}
.content{
    color: #000;
    font-size: .18rem;
}
.contact{
    color: #fff;
    .contactBox{
        // background-color: #1d7e83;

        /* 设置三个背景图片 */
        background-image: 
            url('../assets/btnbg_01.png'), 
            url('../assets/btnbg_03.png'),
            url('../assets/btnbg_02.png'); 

        /* 设置背景图片的尺寸，这次我们使用cover让中间图片填充div */
        background-size: 
        contain, 
        contain, 
            100% 80%;
        /* 分别定位三张图片：上0%，中50%，下100% */
        background-position: 
            top, 
            bottom,
            center .32rem;
        /* 确保图片在垂直方向上不重复 */
        background-repeat: no-repeat;

        border-radius: .05rem;
        padding:.3294867rem .12rem .408637rem;
        position: fixed;
        right: .2rem;
        bottom:30%;
        z-index: 2037;
        // border: 1px solid #fff3;
        .icon{
            height: .3rem;
        }
        .iconText{width: .8rem;margin-bottom: .2rem;}
        .line{
            display: inline-block;
            margin: .1rem 0;
            width: 100%; 
            height: .02rem; 
            background-color: rgba(255, 255, 255, .2);
        }
        .slide-title{
            margin-top: .06rem;
            font-size: .12rem;
        }
    }
}
@media (min-width:1920px){
    .contactBox{
        right: calc((100vw - 1920px) / 2 + .2rem)!important;
    }
}
@media (max-width:767px){
.wecomCode{
    width: 3rem;
}
.content{
    font-size: .26rem;
}
.contact{
    .contactBox{
        padding: .32315rem .12rem .40077876rem;

        /* 设置背景图片的尺寸，这次我们使用cover让中间图片填充div */
        background-size: 
        contain, 
        contain, 
            100% 82%;
        /* 分别定位三张图片：上0%，中50%，下100% */
        background-position: 
            top, 
            bottom,
            center .32rem;

        .icon{
            height: .5rem;
        }
        .iconText{width: .9rem;margin-bottom: .3rem;}
        .slide-title{
            font-size: .2rem;
        }
    }
}

}
</style>


// WEBPACK FOOTER //
// src/components/contact.vue